import { Box, useMediaSize } from '@ally/metronome-ui'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useHostServices } from '../HostServices'
import FDICBannerDesktop from '../assets/images/FDIC_Banner_Desktop.svg'
import FDICBannerMobile from '../assets/images/FDIC_Banner_Mobile.svg'

// Allow the FDIC banner text to scale sizes, when the viewport goes below our smallest expected screen size (Edge Case - We generally want the text at the provided size)
const FDICBannerWrapper = styled(Box)`
  display: flex;
  align-items: center;

  @media screen and (max-width: 350px) {
    svg {
      height: auto;
      width: 100%;
    }
  }
`

const FDIC_BANNER_SCREEN_READER_TEXT =
  'Note: Ally Bank is F.D.I.C-insured, backed by the full faith and credit of the US government.'

export const FDICBanner: React.FC<{ className?: string }> = ({ className }) => {
  const { header, featureFlags } = useHostServices()
  const isLgUp = useMediaSize('LgUp')

  // This subscription state will eventually be handled by a utility created for Host Services subscriptions
  const [showFDICBanner, setShowFDICBanner] = useState(false)

  const isFDICBannerEnabled = featureFlags.variation(
    'FF_fdic-digital-signage',
    false,
  )

  // This subscription will eventually be handled by a utility created for Host Services subscriptions
  useEffect(() => {
    const headerServiceSubscription = header.state$.subscribe(state => {
      setShowFDICBanner(state.showFDICBanner)
    })

    return () => {
      headerServiceSubscription.unsubscribe()
    }
  }, [])

  if (!showFDICBanner || !isFDICBannerEnabled) return null

  if (isLgUp)
    return (
      <FDICBannerWrapper className={className}>
        <FDICBannerDesktop
          data-testid="fdic-banner-desktop"
          role="img"
          title={FDIC_BANNER_SCREEN_READER_TEXT}
          aria-label={FDIC_BANNER_SCREEN_READER_TEXT}
        />
      </FDICBannerWrapper>
    )

  return (
    <FDICBannerWrapper className={className}>
      <FDICBannerMobile
        data-testid="fdic-banner-mobile"
        role="img"
        title={FDIC_BANNER_SCREEN_READER_TEXT}
        aria-label={FDIC_BANNER_SCREEN_READER_TEXT}
      />
    </FDICBannerWrapper>
  )
}
